import { ReactComponent as IconInfo } from '@/assets/svgs/Info.svg'
import { ReactComponent as IconOrganisation } from '@/assets/svgs/Organisation.svg'
import { ReactComponent as IconChevronRight } from '@/assets/svgs/chevron-right.svg'
import { ReactComponent as IconInformation } from '@/assets/svgs/i.svg'
import { ReactComponent as IconBuilding } from '@/assets/svgs/icon-building-transparent.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconDataExchange } from '@/assets/svgs/icon-data-exchange.svg'
import { ReactComponent as IconData } from '@/assets/svgs/icon-data.svg'
import { ReactComponent as IconGear } from '@/assets/svgs/icon-gear.svg'
import { ReactComponent as IconLink } from '@/assets/svgs/icon-link.svg'
import { ReactComponent as IconPerson } from '@/assets/svgs/icon-persona.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import Button from '@/components/Button/index'
import DataElementSharingModal2 from '@/components/DataElementSharingModal2/index'
import Loader from '@/components/DataTableLoader/index'
import InputSuffixIcon from '@/components/InputSuffixIcon/index'
import Modal from "@/componentsDS/Modal/Modal";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Portal from '@/components/Portal'
import Tabs, { Tab } from '@/components/Tabs/index'
import Toast from '@/components/Toast'
import { EnrolmentTypes } from '@/constants/use-case/enrolment'
import useDataElementEnrolments from '@/hooks/use-data-elements-enrolments/index'
import useModal from '@/hooks/use-modal'
import usePage from '@/hooks/use-page/index'
import usePersona from '@/hooks/use-personas/index'
import usePrincipals from "@/hooks/use-principal/index"
import useRequests from '@/hooks/use-requests/index'
import useStatus from '@/hooks/use-status/index'
import useToast from '@/hooks/use-toast'
import useUseCases from '@/hooks/use-use-cases/index'
import { useNavigate, useParams } from '@/lib/router-dom/index'
import API_DATA_ELEMENTS_REQUEST from '@/services/api/dataElementsEnrolment'
import handleSubPrincipals from "@/utils/handle-subscriptionPrincipal"
import { getPrincipalCount } from '@/utils/principal-storage'
import rem from '@/utils/rem'
import titleCase from '@/utils/title-case'
import { getUseCaseId } from "@/utils/use-case-storage"
import { MasonryGrid } from "@egjs/react-grid"
import moment from 'moment'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import PersonaInfoModal from './components/PersonaInfoModal/index'
import SetupEtrIssuanceCard from './etr-issuance/setup-etr-issuance-card/setup-etr-issuance-card'
import { feature } from '@/utils/feature-verifier'
import { featureConstant } from '@/constants/configuration/feature'
import Search from '@/componentsDS/Search/index';
import Tags from '@/componentsDS/Tags/Tags';
import Breadcrumbs from '@/componentsDS/Breadcrumbs/index'


const Page = () => {
	/*=================================================
		General
	/================================================*/
	const user = useSelector(state => state.auth.user)
	const { useCaseId } = useParams()
	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);
	const statuses = {
		approved: "APPROVED",
		rejected: "REJECTED",
		revoked: "REVOKED",
		pending: "PENDING"
	}

	const toastType = {
		success: "success",
		error: "error"
	}

	const requestTypes = {
		review: "REVIEW",
		request: "REQUEST"
	}

	const pageTitle = 'Dashboard'
	const subPageTitle = useCase?.name

	const [participantDetails, setParticipantDetails] = useState();

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: '/'
			},
			{
				label: 'Use Cases',
				link: '/use-cases/enrolment'
			},
			{
				label: subPageTitle,
				link: ''
			},
		]
	})

	const { goTo } = useNavigate()


	const pageLimit = 5

	const [requestType, setRequestType] = useState()
	const [participantSearch, setParticipantSearch] = useState()
	const [principalCount, setPrincipalCount] = useState(getPrincipalCount())

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()
	const { myPitstops, fetchMyPitstops, error: errorStatus, loading: loadingStatus } = useStatus()
	const { items: dataElementsItems, fetch: fetchDataElements, error: errorDataElementEnrolments, loading: loadingDataElements } = useDataElementEnrolments()
	const { items: reviewItems, fetch: fetchReview, currentItem: currentReviewItem, view: viewReviewItem, error: errorReviewRequests, loading: loadingReview } = useRequests([])
	const { items: requestItems, fetch: fetchRequest, error: errorRequestRequests, loading: loadingRequest } = useRequests([])
	const { fetch: fetchPersonas, findAndSetCurrentPersona, items: personaItems, currentItem: currentPersonaItem, error: errorPersona, loading: loadingPeronsas } = usePersona()
	const { find: fetchUseCase, currentItem: useCaseItem, setCurrentItem: setCurrentUseCaseItem, isAgentPrincipalEnabled, loading: loadingUseCases } = useUseCases()
	const { find: findPrincipals, loading: loadingPrincipals } = usePrincipals()
	const isAgentPrincipalPhase2Enabled = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2);
	const isTokenRegistryFeatureEnabled = feature(featureConstant.IG_PNI_TOKEN_REGISTRY);

	const getUseCase = {
		useCaseId: useCaseId,
		all: true
	};

	const fetchEnrollPersona = {
		useCaseId: useCaseId,
		orgId: user.organizationId
	}

	const fetchDataElementProviding = {
		useCaseId: useCaseId,
		type: EnrolmentTypes.provider,
		pageSize: pageLimit,
	}

	function fetchHandler(type) {
		const getAllReview = {
			status: statuses.pending,
			isRequester: false,
		}

		const getAllRequests = {
			isRequester: true,
		}

		let payload = {
			pageSize: pageLimit,
			useCaseId: useCaseId
		};

		if (type === requestTypes.review) {
			payload = {
				...payload,
				...getAllReview,
			};

			return fetchReview(payload)
		}

		if (type === requestTypes.request) {
			payload = {
				...payload,
				...getAllRequests,
			};

			return fetchRequest(payload)
		}
	}

	useEffect(() => {
		async function getData() {
			fetchMyPitstops()
			fetchDataElements(fetchDataElementProviding)
			fetchHandler(requestTypes.review)
			fetchPersonas(fetchEnrollPersona)
			const data = await fetchUseCase(getUseCase)
			if (data?.length > 0) {
				setCurrentUseCaseItem(data[0])
				setParticipantSearch(data[0].enrolledParticipants)
			}
		}

		setElementTabs(filterDataElementTabs(elementsBtns[0].tabs))
		getData()
		findPrincipalCount()
	}, [])

	const findPrincipalCount = async () => {
		if (principalCount > 0) return principalCount;
		if (loadingPrincipals) return;

		const principalItems = await findPrincipals()
		setPrincipalCount(principalItems?.length ?? 0)
	}

	useEffect(() => {
		window.dispatchEvent(new Event('resize'));
	}, [fetchMyPitstops, fetchDataElements, fetchReview, fetchRequest, fetchPersonas])

	useEffect(() => {
		addToastMessage(errorStatus, toastType.error)
	}, [errorStatus])

	useEffect(() => {
		addToastMessage(errorDataElementEnrolments, toastType.error)
	}, [errorDataElementEnrolments])

	useEffect(() => {
		addToastMessage(errorReviewRequests, toastType.error)
	}, [errorReviewRequests])

	useEffect(() => {
		addToastMessage(errorRequestRequests, toastType.error)
	}, [errorRequestRequests])

	useEffect(() => {
		addToastMessage(errorPersona, toastType.error)
	}, [errorPersona])

	/*=================================================
		Tabs
	/================================================*/

	const [requestTabs, setRequestTabs] = useState([
		{ label: 'For Review', active: true, isRequester: false },
		{ label: 'My Requests', active: false, isRequester: true }
	])

	const [elementsBtns, setElementsBtn] = useState([
		{
			label: 'Sharing',
			active: true,
			id: 'SHARING',
			tabs: [
				{ label: 'Contribute', active: true, id: EnrolmentTypes.provider },
				{ label: 'Provide On Behalf', active: false, id: EnrolmentTypes.provideOnBehalf },
				{ label: 'Provide On Behalf (Principal)', active: false, id: EnrolmentTypes.provideOnBehalfOfPrincipal },
			]
		},
		{
			label: 'Receiving',
			active: false,
			id: 'RECEIVING',
			tabs: [
				{ label: 'Consume', active: true, id: EnrolmentTypes.consumer },
				{ label: 'Consume On Behalf', active: false, id: EnrolmentTypes.consumeOnBehalf },
				{ label: 'Consume On Behalf (Principal)', active: false, id: EnrolmentTypes.consumeOnBehalfOfPrincipal },
			]
		},
	]);

	const [elementsTabs, setElementTabs] = useState([
		{ label: 'Contribute', active: true, id: EnrolmentTypes.provider },
		{ label: 'Provide on behalf', active: false, id: EnrolmentTypes.provideOnBehalf },
		{ label: 'Receive on behalf', active: false, id: EnrolmentTypes.consumeOnBehalf },
		{ label: 'Consume', active: false, id: EnrolmentTypes.consumer }
	])

	function selectRequestTab(index) {
		const tabs = [...requestTabs].map(item => ({ ...item, active: false }))
		tabs[index].active = true

		if (index === 0) {
			fetchHandler(requestTypes.review)
		}

		if (index === 1) {
			fetchHandler(requestTypes.request)
		}

		setRequestTabs(tabs)
	}

	function getActiveTab() {
		return requestTabs.filter(item => item.active)
	}

	function filterDataElementTabs(tabs) {
		const tabOptions = tabs?.filter(s => isAgentPrincipalEnabled(useCase?.agentStatus) ? true : !s?.id?.includes('PRINCIPAL')) ?? tabs;
		if (!feature(featureConstant.AGENT_PRINCIPAL_PHASE_2)) {
			return tabOptions?.filter(s => s?.id !== EnrolmentTypes.provideOnBehalfOfPrincipal);
		}
		return tabOptions;
	}

	function selectElementTab(index) {
		const tabs = [...elementsTabs].map(item => ({ ...item, active: false }))
		tabs[index].active = true

		setElementTabs(tabs)
	}

	function selectElementBtn(index) {
		const btns = [...elementsBtns].map(item => ({ ...item, active: false }))
		btns[index].active = true

		setElementsBtn(btns)

		setElementTabs(filterDataElementTabs(elementsBtns[index].tabs));
		fetchDataElements({ type: elementsBtns[index].tabs[0].id, useCaseId: useCaseId, pageSize: pageLimit, })
	}

	/*=================================================
		Systems
	/================================================*/

	const SystemList = ({ data }) => {
		return (
			<div className="layout-dashboard__rows" data-testid="layout">
				{data.map((pitstop, index) => {
					return (
						<div className="layout-dashboard__row" key={index} data-testid="layout">
							<div className="layout-dashboard__cols">
								<div className="layout-dashboard__col">
									<div className="layout-dashboard__col__content">
										<div className="layout-dashboard__content__avatar" style={{ backgroundImage: `url(${pitstop.image})` }}></div>
										<div className="layout-dashboard__content__text">
											<div className="layout-dashboard__content__top">
												{pitstop.name}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					)
				})}
				{
					data.length === 0 && (
						<>
							<div className="layout-dashboard__row">
								<div className="layout-dashboard__cols">
									<div className="layout-dashboard__col">
										<div className="layout-dashboard__col__content">
											<div className="layout-dashboard__content__text">
												<div className="layout-dashboard__content__top">
													There's no system found
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</>
					)
				}
			</div>
		)
	}

	/*=================================================
		Request List
	/================================================*/

	const RequestList = ({ data, requestingType }) => {
		const activeTab = getActiveTab()
		const requestText = !activeTab[0].isRequester ? "you" : ''; // add 'you' for Reviews tab only
		function getTypeName(type) {
			switch (type) {
				case EnrolmentTypes.consumer: return `Request ${requestText} to Consume`;
				case EnrolmentTypes.provider: return `Request ${requestText} to Contribute`;
				case EnrolmentTypes.provideOnBehalf: return `Request ${requestText} to Provide on behalf of`;
				case EnrolmentTypes.consumeOnBehalf: return `Request ${requestText} to Consume on behalf of`;
				case EnrolmentTypes.provideOnBehalfOfPrincipal: return `Request ${requestText} to Provide on behalf (Principal)`;
				case EnrolmentTypes.consumeOnBehalfOfPrincipal: return `Request ${requestText} to Consume on behalf (Principal)`;
				default: return "";
			}
		}
		function getStatusTypeName(type) {
			if (type === statuses.pending) {
				return "In Progress"
			}

			if (type === statuses.approved) {
				return "Approved"
			}

			if (type === statuses.rejected) {
				return "Rejected"
			}

			if (type === statuses.revoked) {
				return "Revoked"
			}
		}

		function statusTag(status) {
			const statusText = getStatusTypeName(status);
			return (
				<>
					{status === statuses.approved && <Tags label={statusText} tagClassName="DS__tag--success" />}
					{(status === statuses.rejected || status === statuses.revoked) && <Tags label={statusText} tagClassName="DS__tag--critical" />}
					{status === statuses.pending && <Tags label={statusText} tagClassName="DS__tag--warning" />}

				</>
			)
		}

		const list = data?.map((item, index) => {
			return (
				index < 5 &&
				<div className="layout-dashboard__row" key={index}>
					<div className="layout-dashboard__cols">
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-dashboard__content__avatar" style={{ backgroundImage: `url(${item?.participant?.iconUrl})` }}></div>
								<div className="layout-dashboard__content__text">
									<div className="layout-dashboard__content__top">
										{item?.participant?.name}
									</div>
									<div className="layout-dashboard__content__bottom">
										<div className="layout-dashboard__content__bottom__cols">
											<div className="layout-dashboard__content__bottom__col layout-dashboard__content__bottom__col--fixed-width">
												{getTypeName(item.type)}
											</div>
											<div className="layout-dashboard__content__bottom__col">
												{moment(item.created).format('DD MMM YYYY')}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="layout-dashboard__col">
							{(item.participant?.subscriptionPrincipals?.some((p) => p?.status === "PENDING")
								|| (item?.status === statuses.pending && (!isAgentPrincipalPhase2Enabled ? requestingType === requestTypes.review : true)))
								&& (isAgentPrincipalPhase2Enabled ? requestingType === requestTypes.review : true) && (
									<>
										<div className="layout-dashboard__col__buttons">
											<Button text="Approve" maxWidth="120" sizing="mini"
												submit={() => {
													setRequestType("APPROVED")
													showConfirmation()
													viewReviewItem(item.id)
												}}
											/>

											<Button text="Decline" ghost maxWidth="90" sizing="mini"
												submit={() => {
													setRequestType("REJECTED")
													showConfirmation()
													viewReviewItem(item.id)
												}}
											/>
										</div>
									</>
								)}
							{item.status && requestingType === requestTypes.request && (
								<>
									{statusTag(item.status)}
								</>
							)}
						</div>
					</div>
				</div>
			)
		})
		return list.length > 0 ? list :
			<div className="layout-dashboard__row">
				<div className="layout-dashboard__cols">
					<div className="layout-dashboard__col">
						<div className="layout-dashboard__col__content">
							<div className="layout-dashboard__content__text">
								<div className="layout-dashboard__content__top">
									There are no requests.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			;
	}

	/*=================================================
		Data Element List
	/================================================*/

	const DataElementList = ({ data }) => {
		const list = data.map((item, index) => {
			return (
				<div className="layout-dashboard__row" key={index}>
					<div className="layout-dashboard__cols">
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-dashboard__content__text">
									<div className="layout-dashboard__content__top">
										{item?.dataElement?.dataElementName}
									</div>
								</div>
							</div>
						</div>
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-dashboard__content__avatar__list">
									{item?.participants?.length > 0 && item.participants.map((participant, index) => {
										return (
											index < 2 &&
											<div key={index} className="layout-dashboard__content__avatar" style={{ backgroundImage: `url(${participant?.organization?.image})` }} ></div>
										)
									})}
								</div>
								{item.participants.length > 2 && (
									<div className="layout-dashboard__content__sub-text">
										<div className="layout-dashboard__content__center">
											+ {item.participants.length - 2}
										</div>
									</div>
								)}
								<div className="layout-dashboard__content__action" id="data-element-details-icon" data-testid="viewDetail-btn"
									onClick={() => goToDataElementDetail(item)}
									tabIndex={0}
									onKeyPress={() => {
										goToDataElementDetail(item)
									}}
								>
									<IconChevronRight id="data-element-details-icon" />
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		})

		return (
			list.length > 0 ? list : (
				<div className="layout-dashboard__row">
					<div className="layout-dashboard__cols">
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-dashboard__content__text">
									<div className="layout-dashboard__content__top">
										No Data Element Found
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		);
	}

	/*=================================================
		Personas List
	/================================================*/

	const PersonaList = ({ data }) => {
		const list = data.filter(item => item?.status === statuses.approved || item?.status === statuses.pending).map((item, index) => {
			return (
				<div className="layout-dashboard__row" key={index}>
					<div className="layout-dashboard__cols">
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-dashboard__content__text">
									<div className="layout-dashboard__content__top">
										{item.name}
									</div>
									<div className="layout-dashboard__content__bottom">
										{item?.status === statuses.pending && (
											<div className="layout-dashboard__content__bottom__cols">
												Pending
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-dashboard__content__action" id="my-persona-details-icon"
									onClick={async () => {
										await findAndSetCurrentPersona({ personaId: item.id, useCaseId: useCaseId })
										showPersonaInfo()
									}}
									onKeyPress={async () => {
										await findAndSetCurrentPersona({ personaId: item.id, useCaseId: useCaseId })
										showPersonaInfo()
									}}
								>
									<IconInfo id="my-persona-details-icon" />
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		})

		return list.length > 0 ? list :
			<div className="layout-dashboard__row">
				<div className="layout-dashboard__cols">
					<div className="layout-dashboard__col">
						<div className="layout-dashboard__col__content">
							<div className="layout-dashboard__content__text">
								<div className="layout-dashboard__content__top">
									You don't have any persona for this use case.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			;
	}

	/*=================================================
		BlockChain List
	/================================================*/

	const BlockChainList = ({ data }) => {
		const filteredData = isTokenRegistryFeatureEnabled
			? data
				.filter((s) => s?.contractAddress?.length > 0)
				.filter((item, index, self) => self.findIndex((t) => t.name === item.name) === index)
			: data.filter((s) => s?.contractAddress?.length > 0);



		if (filteredData.length === 0) {
			return (
				<div className="no-blockchain--error">
					<div className="no-blockchain--error-icon">
						<IconInfo />
					</div>
					<div className="no-blockchain--error-text">
						No Blockchain included for ETR Issuance.
					</div>
				</div>
			);
		}

		return filteredData.map((item) => (
			<div className="layout-dashboard__row" key={item?.networkID}>
				<div className="layout-dashboard__cols">
					<div className="layout-dashboard__col">
						<div className="layout-dashboard__col__content">
							<div className="layout-dashboard__content__text">
								<div className="layout-dashboard__content__top">
									{item?.name}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		));
	};

	BlockChainList.propTypes = {
		data: PropTypes.array.isRequired
	}

	/*=================================================
		Participants List
	/================================================*/

	const ParticipantList = ({ data }) => {
		const list = data.map((item, index) => {
			return (
				<div className="layout-dashboard__row" key={index}>
					<div className="layout-dashboard__cols">
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-dashboard__content__avatar" style={{ backgroundImage: `url(${item.image})` }}>
									{/* <span className="layout-dashboard__content__avatar--text" data-text={getInitial(item.name)} >{item.name}</span> */}
								</div>
								<div className="layout-dashboard__content__text">
									<div className="layout-dashboard__content__top">
										{item.name}
									</div>
								</div>
							</div>
						</div>
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-dashboard__content__text">
									<div className="layout-dashboard__content__bottom">
										<div className="layout-dashboard__content__bottom__cols">
											<div className="layout-dashboard__content__bottom__col">
												{item.type}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="layout-dashboard__col">
							<div className="layout-dashboard__col__content">
								<div className="layout-participant-dashboard__content__action" onClick={() => {
									setParticipantDetails(item);
									showParticipantModal()
								}}
									onKeyPress={() => {
										setParticipantDetails(item);
										showParticipantModal()
									}}
								>
									<IconInfo />
								</div>
							</div>
						</div>

					</div>
				</div>
			)
		})

		return list.length > 0 ? list :
			<div className="layout-dashboard__row">
				<div className="layout-dashboard__cols">
					<div className="layout-dashboard__col">
						<div className="layout-dashboard__col__content">
							<div className="layout-dashboard__content__text">
								<div className="layout-dashboard__content__top">
									There are no participant yet
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			;
	}

	/*=================================================
		Modal
	/================================================*/

	const { visible: visibleConfirmation, show: showConfirmation, hide: hideConfirmation } = useModal()
	const { visible: visiblePersonaInfo, show: showPersonaInfo, hide: hidePersonaInfo } = useModal()
	const { visible: participantModal, show: showParticipantModal, hide: hideParticipantModal } = useModal()
	const { visible: initiateDataElementModal, show: showInitiateDataElementModal, hide: hideInitiateDataElementModal } = useModal()

	/*=================================================
		API Action Functions
	/================================================*/

	async function requestAction() {
		let approvedAllSubPrincipal = handleSubPrincipals(currentReviewItem, statuses.approved)
		let rejectAllSubPrincipal = handleSubPrincipals(currentReviewItem, statuses.rejected)

		const payload = {
			type: currentReviewItem.type,
			organizationId: currentReviewItem.organizationId,
			dataElementId: currentReviewItem.dataElementId,
			useCaseId: currentReviewItem.useCaseId,
		}

		if (requestType === statuses.approved) {
			payload.subscriptionPrincipals = approvedAllSubPrincipal;
		}

		if (requestType === statuses.rejected) {
			payload.subscriptionPrincipals = rejectAllSubPrincipal;
		}

		const [error, result] = await API_DATA_ELEMENTS_REQUEST.update(requestType, payload)

		if (error) {
			return addToastMessage(error?.message, toastType.error)
		}

		const request = requestType === statuses.approved ? "successfully accepted" : "rejected"
		addToastMessage(`You have ${request} the data request.`, toastType.success)

		fetchHandler(requestTypes.review)
	}

	/*=================================================
		Navigate
	/================================================*/

	function goToViewAllDataRequest() {
		goTo(`/use-cases/${useCaseId}/requests-list`)
	}

	function goToSystemPage() {
		goTo(`/use-cases/${useCaseId}/system-monitoring`)
	}

	function goToViewDataElementsPage() {
		goTo(`/use-cases/${useCaseId}/data-elements-list`, {
			type: elementsTabs.find(i => i.active)?.id,
			chip: elementsBtns.find(i => i.active)?.id,
		})
	}

	function goToEditPersonaPage() {
		goTo(`/use-cases/${useCaseId}/edit-personas`)
	}

	function goToDataElementDetail(item) {
		let type = elementsTabs.find(i => i.active)?.id;
		goTo(`/use-cases/${useCaseId}/data-elements/${item.dataElement.dataElementId}/${type.toLowerCase()}`)
	}

	function goToEtrIssuancePersonaEnroll() {
		goTo(`/use-cases/${useCaseId}/edit-issuance`)
	}

	/*=================================================
		Additional Function
	/================================================*/

	function handleSearchParticipant(e) {
		const search = e.target.value

		if (!search) {
			return setParticipantSearch(useCaseItem?.enrolledParticipants)
		}

		const updatedItem = participantSearch?.filter(item => item.name.toLowerCase().includes(search.toLowerCase()))

		setParticipantSearch(updatedItem)
	}


	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{subPageTitle}</div>
				</div>
				<div className="title-header__right"></div>
			</div>

			<MasonryGrid
				className="layout-dashboard__container"
				gap={24}
				defaultDirection={"end"}
				align={"start"}
				autoResize={true}
			>
				<div className="layout-dashboard__block">
					<div className="layout-dashboard__tile__header">
						<div className="layout-dashboard__tile__header__left">
							<div className="layout-dashboard__title">
								<div className="layout-dashboard__title__avatar">
									<IconGear />
								</div>
								<div className="layout-dashboard__title__text">
									<div className="layout-dashboard__title__text__top layout-dashboard__main-title">
										Connected Pitstop
									</div>
								</div>
							</div>
						</div>
					</div>
					<Loader loading={loadingStatus}>
						<div className="layout-dashboard__tile__body">
							<SystemList data={myPitstops || []} />
						</div>
						<div className="layout-dashboard__tile__footer">
							<div
								className="link"
								data-testid="connectedPitstopViewAll"
								onClick={() => goToSystemPage()}
								onKeyPress={() => goToSystemPage()}
							>
								View all
							</div>
						</div>
					</Loader>
				</div>

				<div className="layout-dashboard__block">
					<div className="layout-dashboard__tile__header">
						<div className="layout-dashboard__tile__header__left">
							<div className="layout-dashboard__title">
								<div className="layout-dashboard__title__avatar">
									<IconDataExchange />
								</div>
								<div className="layout-dashboard__title__text">
									<div className="layout-dashboard__title__text__top layout-dashboard__main-title">
										Data Requests
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="layout-dashboard__tile__body">
						<div className="layout-dashboard__body__tabs">
							<Tabs>
								{requestTabs.map((item, index) => (
									<Tab
										key={index}
										label={item.label}
										active={item.active}
										onClick={() => {
											selectRequestTab(index);
										}}
									/>
								))}
							</Tabs>
						</div>
					</div>
					<Loader loading={loadingReview || loadingRequest}>
						{requestTabs[0].active && (
							<RequestList
								data={reviewItems || []}
								requestingType={requestTypes.review}
							/>
						)}
						{requestTabs[1].active && (
							<RequestList
								data={requestItems || []}
								requestingType={requestTypes.request}
							/>
						)}
						<div className="layout-dashboard__tile__footer">
							{requestTabs[0].active && (
								<div className="link" data-testid="dataRequestsViewAll"
									onClick={() => goToViewAllDataRequest()}
									onKeyPress={() => goToViewAllDataRequest()}
								>
									View all
								</div>
							)}
							{requestTabs[1].active &&
								<div className="link" data-testid="dataRequestsViewAll"
									onClick={() => goToViewAllDataRequest()}
									onKeyPress={() => goToViewAllDataRequest()}
								>
									View all
								</div>
							}
						</div>
					</Loader>
				</div>

				<div className="layout-dashboard__block">
					<div className="layout-dashboard__tile__header">
						<div className="layout-dashboard__tile__header__left">
							<div className="layout-dashboard__title">
								<div className="layout-dashboard__title__avatar">
									<IconData />
								</div>
								<div className="layout-dashboard__title__text">
									<div className="layout-dashboard__title__text__top layout-dashboard__main-title">
										Data Elements
									</div>
								</div>
							</div>
						</div>
						<div className="layout-dashboard__tile__header__right">
							<Button
								submit={() => {
									showInitiateDataElementModal();
								}}
								text="Add Data Element"
							/>
						</div>
					</div>
					<div className="layout-dashboard__tile__body">
						<div className="layout-dashboard__body__chips">
							{elementsBtns.map((item, index) => (
								<Button
									key={index}
									text={item.label}
									ascent
									selected={item.active}
									sizing="mini"
									round
									submit={() => {
										selectElementBtn(index);
									}}
								/>
							))}
						</div>

						<div className="layout-dashboard__body__tabs">
							<Tabs>
								{elementsTabs.map((item, index) => (
									<Tab
										data-testid={item.id}
										key={index}
										label={item.label}
										active={item.active}
										onClick={() => {
											selectElementTab(index);
											fetchDataElements({
												type: item?.id,
												useCaseId: useCaseId,
												pageSize: pageLimit,
											});
										}}
									/>
								))}
								<div></div>
							</Tabs>
						</div>
					</div>
					<Loader loading={loadingDataElements}>
						<DataElementList
							data={dataElementsItems || []}
						/>
						{dataElementsItems.length > 0 && (
							<div className="layout-dashboard__tile__footer">
								<div className="link" data-testid="dataElementViewAll"
									onClick={() => goToViewDataElementsPage()}
									onKeyPress={() => goToViewDataElementsPage()}
								>
									View all
								</div>
							</div>
						)}
					</Loader>
				</div >

				{(useCaseItem?.enableETR) &&
					(!useCaseItem?.etrIssuance?.isEnabled && !personaItems.some(s => s?.is_etr_issuer && s?.status === 'APPROVED') ? (
						<SetupEtrIssuanceCard />
					) : (
						<div className="layout-dashboard__block layout-dashboard__block--no-footer">
							<div className="layout-dashboard__tile__header">
								<div className="layout-dashboard__tile__header__left">
									<div className="layout-dashboard__title">
										<div className="layout-dashboard__title__avatar">
											<IconLink />
										</div>
										<div className="layout-dashboard__title__text">
											<div className="layout-dashboard__title__text__top layout-dashboard__main-title">
												Blockchain
											</div>
										</div>
									</div>
								</div>
								<div className="layout-dashboard__tile__header__right">
									<Button
										text="Edit Configuration"
										id="edit-configuration-button"
										submit={() => goToEtrIssuancePersonaEnroll()}
									/>
								</div>
							</div>
							<Loader loading={loadingUseCases}>
								<div className="layout-dashboard__tile__body">
									<BlockChainList data={useCaseItem?.etrIssuance?.contracts || []} />
								</div>
							</Loader>
						</div>
					))
				}

				<div className="layout-dashboard__block layout-dashboard__block--no-footer">
					<div className="layout-dashboard__tile__header">
						<div className="layout-dashboard__tile__header__left">
							<div className="layout-dashboard__title">
								<div className="layout-dashboard__title__avatar">
									<IconPerson />
								</div>
								<div className="layout-dashboard__title__text">
									<div className="layout-dashboard__title__text__top layout-dashboard__main-title">
										My Personas
									</div>
								</div>
							</div>
						</div>
						<div className="layout-dashboard__tile__header__right">
							<Button
								text="Edit Personas"
								id="edit-personas-button"
								submit={() => goToEditPersonaPage()}
							/>
						</div>
					</div>
					<Loader loading={loadingPeronsas}>
						<div className="layout-dashboard__tile__body">
							<PersonaList data={personaItems || []} />
						</div>
					</Loader>
				</div>

				<div className="layout-dashboard__block layout-dashboard__block--no-footer">
					<div className="layout-dashboard__tile__header">
						<div className="layout-dashboard__tile__header__left">
							<div className="layout-dashboard__title">
								<div className="layout-dashboard__title__avatar">
									<IconBuilding />
								</div>
								<div className="layout-dashboard__title__text">
									<div className="layout-dashboard__title__text__top layout-dashboard__main-title">
										All Participants
									</div>
									<div className="layout-dashboard__title__text__bottom layout-dashboard__sub-title">
										in {useCase?.name}
									</div>
								</div>
							</div>
						</div>
						<div className="layout-dashboard__search">
							{
								feature(featureConstant.NEW_DESIGN_SYSTEM) ? (
									<Search onChange={handleSearchParticipant} />
								) : (

									<InputSuffixIcon
										placeholder="Search"
										icon={<IconSearch />}
										onChange={(e) => {
											handleSearchParticipant(e);
										}}
										defaultValue={""}
									/>
								)
							}
						</div>
					</div>
					<Loader loading={loadingUseCases}>
						<div className="layout-dashboard__tile__body layout-dashboard__tile__body--scrollable">
							<ParticipantList data={participantSearch || []} />
						</div>
					</Loader>
				</div>
			</MasonryGrid >

			<PersonaInfoModal
				visible={visiblePersonaInfo}
				hide={hidePersonaInfo}
				persona={currentPersonaItem}
			/>

			<DataElementSharingModal2
				isVisible={initiateDataElementModal}
				hideModal={hideInitiateDataElementModal}
				useCaseId={useCaseId}
				useCaseAgentStatus={useCase.agentStatus}
				principalCount={principalCount}
			/>

			<Modal visible={visibleConfirmation} variant='medium' close={hideConfirmation}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<IconInformation />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{titleCase(requestType)} Request
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							{requestType === statuses.approved && (
								<>
									<div
										style={{
											fontSize: rem(14),
											textAlign: "center",
										}}
									>
										Are you sure you want to proceed to
										approve this request?
									</div>
								</>
							)}
							{requestType === statuses.rejected && (
								<>
									<div
										style={{
											fontSize: rem(14),
											textAlign: "center",
										}}
									>
										Are you sure you want to reject this
										request? You will not be able to
										exchange this data element.
									</div>
								</>
							)}
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								ghost
								text="Yes"
								submit={() => {
									hideConfirmation();
									requestAction();
								}}
							/>

							<span
								style={{
									width: rem(10),
									display: "inline-block",
								}}
							></span>

							<Button
								text="No"
								submit={() => {
									hideConfirmation();
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={participantModal} variant='medium' close={hideParticipantModal}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<div className="layout-dashboard__title__avatar">
												<IconOrganisation />
											</div>
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{participantDetails?.name}
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="persona-info-modal">
								<div className="persona-info-modal__value">
									{participantDetails?.description
										? participantDetails?.description
										: "---"}
								</div>
								<div className="persona-info-modal__title">
									Personas
								</div>
								<div className="flex-display--withWrap">
									{participantDetails?.personas.map(
										(item) => {
											return (
												<span key={item?.id}><Tags label={item.name} tagClassName='DS__tag--system' /></span>
											);
										}
									)}
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer></CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Toast toastList={toastList} />
		</>
	);
}
export default Page
